const projectCardsWrapper = document.querySelector(".js-project-cards");

if (typeof projectCardsWrapper != "undefined" && projectCardsWrapper != null) {

    var swiper = new Swiper(".project-cards", {
        direction: "vertical",
        loop: true,
        loopedSlides: 50,
        slidesPerView: 1,
        centeredSlides: false,
        preventClicks: false,
        shortSwipes: true,
        preventClicksPropagation:false,
        //allowTouchMove: false,
        runCallbacksOnInit: false,
        mousewheel: {
            forceToAxis: true,
            sensitivity: 8
        }, 
        // Navigation arrows
        navigation: {
            nextEl: ".js-project-cards-next",
            prevEl: ".js-project-cards-prev"
        },

        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 1.2,
                shortSwipes: false
            },
            900: {
                slidesPerView: 1.6,
                centeredSlides: true
            }
          }
        //   on: {
        //     init: function () {
        //       console.log('swiper initialized');
              
        //     },
        //     click: function () {
        //         console.log(this.clickedSlide);
        //         console.log('swiper click');
        //       }
        //   },
    });

    swiper.mousewheel.enable(); 

}
